import type { StepDoc } from "@/app/queries";
import { AsideHead } from "./shared";

/** «сегодня» или DD.MM — как в макете. */
export function whenLabel(iso: string, now = new Date()): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  const same = d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth() && d.getDate() === now.getDate();
  if (same) return "сегодня";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${dd}.${mm}`;
}

/** «История изменений»: ревизии черновика с автором и заметкой. */
export function HistoryCard({ history }: { history: StepDoc["history"] }) {
  return (
    <section className="rounded-md border border-bd bg-card p-3.5" data-testid="history">
      <AsideHead title="история изменений" />
      {history.length === 0 ? (
        <p className="m-0 text-[12px] leading-[1.45] text-ink2">Правок ещё не было — первая появится после сохранения.</p>
      ) : (
        <div className="flex flex-col gap-[9px]">
          {history.map((h, i) => (
            <div key={`${h.when}-${i}`} className="grid grid-cols-[62px_minmax(0,1fr)] gap-[9px] text-[12px] leading-[1.45] text-ink2">
              <span className="font-mono text-[10px] text-mut">{whenLabel(h.when)}</span>
              <span className="text-pretty">{h.author ? `${h.author}: ${h.note || "правка"}` : h.note || "правка"}</span>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
